import buildInfo from '../buildInfo.json';

// Compares the buildTime baked into this bundle against /version.json fetched
// fresh off the network (no-store + cache-busting query, since iOS caches the
// PWA shell aggressively and would otherwise never see a newer deploy exists).
export async function checkForUpdate() {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return;

    const latest = await res.json();
    if (!latest.buildTime || latest.buildTime === buildInfo.buildTime) return;

    // Avoid looping if the reload somehow still serves a stale bundle.
    if (sessionStorage.getItem('mm_update_reload') === latest.buildTime) return;
    sessionStorage.setItem('mm_update_reload', latest.buildTime);

    window.location.replace(`${window.location.pathname}?v=${Date.now()}`);
  } catch (err) {
    console.error('❌ Error comprobando actualizaciones:', err);
  }
}
